// extracted by mini-css-extract-plugin
module.exports = {"main-image":"styles-module__main-image___-WWvi"};